import React, { Component } from 'react';
import './HandHistory.css';
import HandHistoryDesktop from './HandHistoryDesktop';
import HandHistoryMobile from './HandHistoryMobile';
import Media from 'react-responsive';
import { apiService } from '../../common/apiCallService';
import Loading from '../Loading.js';
import { baseUrl, domain } from '../../common/config.js';
import { generateCardLinks, saveActivity, updateOnBoard } from "../../common/commonService";
import { connect } from "react-redux";
import EditNoteModal from './EditNoteModal';
import moment from 'moment';
import $ from 'jquery';
import * as actions from "../../store/actions/index";
import HandHistoryFilter from './HandHistoryFilter';
import i18next from 'i18next';
var _ = require('underscore');
import OnBoard from '../MygameOnBoard/OnBoard'
import NewFeature from './NewFeature';
import HandReplayer from '../HandReplayer/HandReplayer';
import ReplayHand from '../HandReplayer/ReplayHand';
import HandLimitModal from './HandLimitModal';
import { getColor, getDarkTextColor, getHoverColor, getTextColor } from '../../common/ThemeService';
import { DispatcherFunction } from 'mygame-components';

class HandHistory extends Component {

    constructor(props) {
        super(props)
        this.state = {
            loading: false,
            handList: [],
            levels: [],
            totalProfit: 0,
            pageNumber: 1,
            showMoreFlag: false,
            totalHands: 0,
            currentEditNotesHand: null,
            showTopButton: false,
            changeFulfilled: true,
            showFilterModal: true,
            showNoteModal: false,
            isOnBoard: localStorage.getItem('mygame_onboarded') === 'N' ? 1 : 0,
            isAllHandsSelected: false,
            selectedHandList: [],
            showReplayBtn: false,
            displayContent: true,
            openMultiHandRep: false,
            currentReplayerHandIndex: 0,
            showHeader: true
        }
    }

    disableOnBoard = async () => {
        this.setState({ loading: true, isOnBoard: 0 })
        await updateOnBoard()
        this.setState({ loading: false })
    }

    getPlayerLevel = (isFirstCall, setFulfilledFlagTrue) => {
        this.setState({ loading: true })
        let reqObj = {
            from: moment(this.props.filter.from).startOf("day").format("YYYY-MM-DD HH:mm:ss").toString(),
            to: moment(this.props.filter.to).startOf("day").format("YYYY-MM-DD HH:mm:ss").toString(),
            gameType: this.props.filter.gameType,
            ringTypes: this.props.filter.ringType === "All" ? ['Heads-up', '6-seater', 'Full Ring'] : [this.props.filter.ringType],
            accountName: localStorage.getItem("accountName"),
        }

        const finalLevelsUrl = baseUrl+ `/pokerwatch/${['cash','Fast Forward'].includes(this.props.filter.gameType) ? 'getPlayerLevelsData' : 'getPlayerBuyinLevelsData'}`;

        apiService(finalLevelsUrl, reqObj, (data) => {
            if (!isFirstCall) {
                this.setState({ loading: false });
            }
            this.setState({
                levels: data.playerLevels,
            })
            let filter = this.props.filter;
            if (!data.playerLevels.includes(filter.level)) {
                filter.level = "All Level";
                this.changeFilter(filter, (isFirstCall ? true : false));
            }
            if (setFulfilledFlagTrue) {
                this.setState({ changeFulfilled: true })
            }
        }, (error) => {
            this.setState({ loading: false })
        })
    }
    changeFilter = (filter, isFirstCall) => {
        if (!isFirstCall) {
            this.setState({ changeFulfilled: false })
        }
        this.props.setHandHistoryFilter(filter);
    }
    componentDidMount = async () => {
        this.setState({ loading: true })
        let reqObj = {
            from: moment(this.props.filter.from).startOf("day").format("YYYY-MM-DD HH:mm:ss").toString(),
            to: moment(this.props.filter.to).startOf("day").format("YYYY-MM-DD HH:mm:ss").toString(),
            accountName: localStorage.getItem("accountName"),
        }
        await new Promise((resolve, reject) => {
            apiService(baseUrl + '/pokerwatch/getGameTypeWithMostHandsAvailable', reqObj, (data) => {
                if (data) {
                    let filter = this.props.filter;
                    filter.gameType = data.gameType;
                    this.changeFilter(filter, true);
                    resolve();
                }
            }, (error) => {
                reject();
            })
        });
        saveActivity({
            hit_page: 'MyHands',
            hit_type: 'Display',
        })
        this.getHandHistory(this.state.pageNumber, this.props.filter);
        window.addEventListener('scroll', this.handleScroll, false);
        this.getPlayerLevel(true);
    }
    componentDidUpdate = () => {
        if (localStorage.getItem("didNewFeatureModalShownOnces") !== "true" && !this.state.showFilterModal) {
            document.getElementById("openNewFeatureModalBtn").click();
            localStorage.setItem("didNewFeatureModalShownOnces", "true")
        }
    }
    componentWillUnmount = () => {
        window.removeEventListener('scroll', this.handleScroll);
    }

    handleScroll = (e) => {
        if (($('html').scrollTop() < 300 && this.state.showTopButton === true) ||
            ($('html').scrollTop() > 300 && this.state.showTopButton === false)) {
            this.setState({ showTopButton: $('html').scrollTop() > 300 ? true : false })
        }
    }

    getHandHistory = async (pageNumber, filter) => {
        this.setState({ loading: true })
        let SB = "All";
        let BB = "All";

        let reqObj = {
            holeCards: filter.holeCards,
            gameType: filter.gameType,
            from: moment(filter.from).startOf("day").format("YYYY-MM-DD HH:mm:ss.SSSZ").toString(),
            to: moment(filter.to).endOf("day").format("YYYY-MM-DD HH:mm:ss.SSSZ").toString(),
            ringTypes: (filter.ringType === "All" ? ['Heads-up', '6-seater', 'Full Ring'] : [filter.ringType]),
            pageNumber,
            sort: filter.sort,
            handType: filter.handType,
            position: filter.position,
            accountName: localStorage.getItem("accountName")
        };
        if(filter.gameType === 'cash' || filter.gameType === 'Fast Forward'){
            if (filter.level && filter.level !== "All Level") {
            [SB, BB] = filter.level.split("/");
            }
            reqObj = {
                level: filter.level,
                SB,
                BB,
                ...reqObj
            }
        }else{
            let buyIn = filter.level === "All Level" ?'All':filter.level;            
            reqObj = {
                buyIn:buyIn,
                ...reqObj
            }
        }
        let handInfoList = []
        let sortFilters=['desc','asc','starred','biggestWins','biggestLosses']
        if (sortFilters.includes(filter.sort)) {
            let reqObj2 = {
                gameType: filter.gameType,
                from:  moment(filter.from).startOf("day").utc().format("YYYY-MM-DD HH:mm:ss.SSSZ").toString(),
                to: moment(filter.to).endOf("day").utc().format("YYYY-MM-DD HH:mm:ss.SSSZ").toString(),
                accountName: localStorage.getItem("accountName"),
                // ringType: filter.ringType,
                // SB,
                // BB,
                // holeCards: filter.holeCards,
            }
            await apiService(baseUrl + '/handInfo/getHandInfoList', reqObj2, (data) => {
                if (data) {
                    handInfoList = data
                }
            }, (error) => {
                console.log("Error", error)
            })
        }

        apiService(baseUrl + '/pokerwatch/getHandHistoryList', reqObj, (data) => {
            if (data) {
                saveActivity({
                    hit_page: 'MyHands',
                    hit_type: 'Search',
                    hit_attribute1: moment(filter.from).startOf("day").format("YYYY-MM-DD HH:mm:ss").toString(),
                    hit_attribute2: (filter.holeCards && filter.holeCards.length > 0) ? filter.holeCards.join(',') : "All",
                    hit_attribute3: filter.gameType,
                    hit_attribute4: data.totalHands.toString(),
                    hit_attribute5: moment(filter.to).startOf("day").format("YYYY-MM-DD HH:mm:ss").toString(),
                })
                this.processData(data, handInfoList);
            } else {
                this.setState({ loading: false });
            }
        }, (error) => {
            console.log("Error", error)
            this.setState({ loading: false })
        })
    }

    setStarFlagOfHnad = (hand, newStarValue) => {
        let reqObj = {
            staredHand: newStarValue,
            accountName: localStorage.getItem("accountName"),
            gameType: hand.gameType,
            gameNo: hand.gameNo,
            time: hand.fullDateTime,
            // SB: hand.SB,
            // BB: hand.BB,
            // ringType: hand.ringType,
            // gameSubType: hand.gameSubType,
            // holeCards: hand.holeCards,
        }
        apiService(baseUrl + '/handInfo/setStarFlagOfHandInfo', reqObj, (data) => {
            this.setState({ loading: false });
            saveActivity({
                hit_page: 'MyHands',
                hit_type: 'FavouriteHand',
                hit_attribute1: hand.gameType,
                hit_attribute2: newStarValue,
                hit_attribute3: hand.gameNo,
                hit_attribute4: hand.fullDateTime
            })
        }, (error) => {
            console.log("Error", error)
            this.setState({ loading: false })
        })
    }
    setLocalHandListStarValue = (hand, newStarValue) => {
        let handList = this.state.handList;
        let newSelectedHandList = this.props.selectedHandList;
        handList.map(handObj => {
            console.log(handObj.gameNo, "===", hand.gameNo, "res:", handObj.gameNo === hand.gameNo)
            if (handObj.gameNo === hand.gameNo && hand.fullDateTime === handObj.fullDateTime) {
                handObj.staredHand = newStarValue;
            }
            return handObj;
        })
        newSelectedHandList.map(handObj => {
            console.log(handObj.gameNo, "===", hand.gameNo, "res:", handObj.gameNo === hand.gameNo)
            if (handObj.gameNo === hand.gameNo && hand.fullDateTime === handObj.fullDateTime) {
                handObj.staredHand = newStarValue;
            }
            return handObj;
        })
        this.setState({ handList });
        this.props.setSelectedHandList(newSelectedHandList)
    }

    handleShowMore = () => {
        const newPageNo = this.state.pageNumber + 1
        this.setState({ pageNumber: newPageNo })
        this.getHandHistory(newPageNo, this.props.filter)
    }
    showMultiReplayer=() => {
        saveActivity({
            hit_page: 'MyHands',
            hit_type: 'MultipleHandsReplay',
        })
        if(window.messageToNative || (window.external && window.external.NativeDispatch)){
          let gameList = [];
          this.props.selectedHandList.map((hand) => {
              gameList.push(hand.gameNo);
          })
          localStorage.setItem("selectedHandList",JSON.stringify(this.props.selectedHandList));
            DispatcherFunction("app:menu=3814&name=MYGAME_REPLAYER",{
                "MYGAME_REPLAYER_URL":'https://' + window.location.hostname +
                `/MultipleReplayerPopup` ,
                "location":"yes",
                "height":"720",
                "width":"1000",
                "scrollbars":"yes",
                "status":"yes"
      })}
          else
        this.setState({ openMultiHandRep: true })
    }

    getHandHistoryOnChange = () => {
        this.setState({ pageNumber: 1, handList: [], totalHands: 0, totalProfit: 0 }, () => {
            this.getHandHistory(1, this.props.filter)
        })
    }

    openNotes = (hand) => {
        this.setState({
            currentEditNotesHand: hand
        }, () => {
            if (hand.notes && hand.notes.length > 3) {
                setTimeout(() => {
                    $("#EditNoteModal_modalBody").scrollTop(hand.notes.length * 68)
                }, 500)
            }
        });
        this.setShowNoteModal(true)
    }

    apiCallMethod = (noteMsg, type, noteId) => {
        saveActivity({
            hit_page: 'MyHands',
            hit_type: 'Notes',
            hit_attribute1: type,
            hit_attribute2: this.state.currentEditNotesHand.gameType,
            hit_attribute3: this.state.currentEditNotesHand.gameNo,
        })
        this.setState({ loading: true })
        let reqObj = {
            gameType: this.state.currentEditNotesHand.gameType,
            gameNo: this.state.currentEditNotesHand.gameNo,
            time: this.state.currentEditNotesHand.fullDateTime,
            // SB: this.state.currentEditNotesHand.SB,
            // BB: this.state.currentEditNotesHand.BB,
            // ringType: this.state.currentEditNotesHand.ringType,
            // gameSubType: this.state.currentEditNotesHand.gameSubType,
            // holeCards: this.state.currentEditNotesHand.holeCards,
            note: noteMsg,
            accountName: localStorage.getItem("accountName"),
            user: localStorage.getItem("first_name") ? localStorage.getItem("first_name") : "",
        }
        let URL = '/handInfo/addHandNote';
        if (type === "Edit" || type === "Delete") {
            reqObj.noteId = noteId;
            if (type === "Delete") {
                reqObj.isDelete = true;
            }
            URL = '/handInfo/editOrDeleteHandNote';
        }
        apiService(baseUrl + URL, reqObj,
            (data) => {
                this.setState({ loading: false });
                let updatedHandObj = this.state.currentEditNotesHand;
                updatedHandObj.notes = data.notes;
                let handList = this.state.handList.map((hand) => {
                    if (hand.gameNo === this.state.currentEditNotesHand.gameNo && this.state.currentEditNotesHand.time === hand.time) {
                        return updatedHandObj
                    } else {
                        return hand
                    }
                })
                this.setState({ currentEditNotesHand: updatedHandObj, handList }, () => {
                    if (type === "Add" && updatedHandObj.notes && updatedHandObj.notes.length > 3) {
                        $("#EditNoteModal_modalBody").scrollTop(updatedHandObj.notes.length * 68)
                    }
                })
            }, (error) => {
                console.log("Error:", error)
                this.setState({ loading: false })
            })
    }

    addNote = (noteMsg) => {
        this.apiCallMethod(noteMsg, "Add")
    }

    editNote = (noteMsg, noteId) => {
        this.apiCallMethod(noteMsg, "Edit", noteId);
    }

    deleteNote = (noteId) => {
        this.apiCallMethod(null, "Delete", noteId);
    }

    processData = (data, handInfoList) => {
        console.log("processData started",data, moment().format("DD-MM-YYYY HH:mm:ss.sss"))
        let hands = [];
        let trueHands=[];
        let falseHands=[];
        data.hands.map((hand) => {
            let handObj = {};
            handObj.notes = [];
            // handObj.staredHand = false;
            if (this.props.filter.sort != "starred") {
                handInfoList.map(handInfo => {
                    if (handInfo.gameNo.toString() === (hand.gameInfo.gameNo ? hand.gameInfo.gameNo.toString() : hand.gameNo.toString()) &&
                        handInfo.time === hand.time) {
                        handObj.notes = handInfo.notes;
                        handObj.staredHand = handInfo.staredHand;
                    }
                })
            } 
            else {
                handObj.notes = hand.notes
                // handObj.staredHand = true;
                // handInfoList.map(handInfo=>{
                //     handObj.staredHand=handInfo.staredHand
                // })
                // console.log('handObj starred ',handObj);
                // handObj.staredHand=true
                console.log('handinfolist starred ',handInfoList)
                handInfoList.map(handInfo => {
                    if (handInfo.gameNo.toString() === (hand.gameInfo.gameNo ? hand.gameInfo.gameNo.toString() : hand.gameNo.toString()) &&
                        handInfo.time === hand.time) {
                        handObj.notes = handInfo.notes;
                        handObj.staredHand = handInfo.staredHand;
                    }
                })
            }
            let date = new Date(hand.time);
            let dd = date.getDate();
            let mm = date.getMonth() + 1; //January is 0!

            let yyyy = date.getFullYear();
            if (dd < 10) {
                dd = '0' + dd;
            }
            if (mm < 10) {
                mm = '0' + mm;
            }
            handObj.currency=hand.currency
            handObj.partitionDate = hand.partitionDate;
            handObj.gameNo = hand.gameInfo.gameNo ? hand.gameInfo.gameNo : hand.gameNo;
            handObj.gameType = hand.gameInfo.gameType;
            handObj.gameSubType = hand.gameInfo.gameSubType;
            handObj.ringType = hand.gameInfo.ringType;
            handObj.SB = hand.gameInfo.blinds.small;
            handObj.BB = hand.gameInfo.blinds.big;
            handObj.holeCards = hand.playerStats.holeCards;
            handObj.position = hand.playerStats.position;
            handObj.date = dd + '/' + mm + '/' + yyyy;
            handObj.time = moment(date).format("HH:mm");
            handObj.fullDateTime = hand.time;
            handObj.cashedout=hand.cashedout;
            handObj.pockeCard = generateCardLinks(hand.playerStats.dealtToCards);
            hand.Actions.map((action) => {
                if (action.action === "flop") {
                    if (Array.isArray(action.cards)) {
                        handObj.flop = action.cards ? generateCardLinks(action.cards) : [];
                    } else {
                        handObj.flop = action.cards ? generateCardLinks(action.cards.split(",")) : [];
                    }
                }
                if (action.action === "turn") {
                    if (Array.isArray(action.cards)) {
                        handObj.turn = action.cards ? generateCardLinks(action.cards) : [];
                    } else {
                        handObj.turn = action.cards ? generateCardLinks([action.cards]) : [];
                    }
                }
                if (action.action === "river") {
                    if (Array.isArray(action.cards)) {
                        handObj.river = action.cards ? generateCardLinks(action.cards) : [];
                    } else {
                        handObj.river = action.cards ? generateCardLinks([action.cards]) : [];
                    }
                }
            });
            if (hand.gameInfo.gameType === "cash") {
                handObj.profit = (hand.playerStats.endStack - hand.playerStats.startStack).toFixed(2);
            } else {
                handObj.profit = (hand.playerStats.profit ? hand.playerStats.profit : 0).toFixed(2);
            }
            hands.push({ ...handObj });
        });

        if (this.props.filter.sort == "starred") {
            hands.map(handx => {
                if (handx.staredHand === true)
                    trueHands.push(handx)
                else
                    falseHands.push(handx)
            })
            hands = trueHands.concat(falseHands)
        }

        let list = this.state.handList;
        this.props.setSelectedHandList([])
        this.setState({
            handList: [...list, ...hands],
            totalProfit: this.state.pageNumber === 1 ? data.profit : this.state.totalProfit,
            totalHands: this.state.pageNumber === 1 ? data.totalHands : this.state.totalHands,
            loading: false,
        }, () => {
            console.log("processData ended", moment().format("DD-MM-YYYY HH:mm:ss.sss"))
            if (this.state.isAllHandsSelected) {
                this.props.setSelectedHandList(this.state.handList)
            }
            if (this.state.handList.length < this.state.totalHands) {
                this.setState({ showMoreFlag: true })
            } else {
                this.setState({ showMoreFlag: false })
            }
        });
    }

    setShowFilterModal = (value) => {
        this.setState({ showFilterModal: value })
    }
    setShowNoteModal = (value) => {
        this.setState({ showNoteModal: value })
    }
    setIsAllHandsSelected = () => {
        this.setState({ displayContent: false }, () => {
            this.setState({ isAllHandsSelected: !this.state.isAllHandsSelected }, () => {
                if (!this.state.isAllHandsSelected) {
                    this.props.setSelectedHandList([])
                    this.setState({ displayContent: true })
                    this.forceUpdate();
                    this.setState({ showReplayBtn: false })
                } else {
                    this.props.setSelectedHandList(this.state.handList)
                    this.setState({ displayContent: true })
                    this.forceUpdate();
                    this.setState({ showReplayBtn: true })
                }
            })
        })
    }
    selectHand = (hand, index) => {
        this.setState({ showReplayBtn: false }, () => {
            this.setState({ showReplayBtn: true })
        })
        let selectedHandList = this.props.selectedHandList;
        selectedHandList.push(hand)
        this.props.setSelectedHandList(selectedHandList)
        if (this.state.handList.length === selectedHandList.length) {
            this.setState({ isAllHandsSelected: true }, this.forceUpdate())
        }
        this.forceUpdate();
    }
    unselectHand = (hand, index) => {
        let selectedHandList = this.props.selectedHandList;
        selectedHandList = selectedHandList.filter(handObj => (handObj.gameNo !== hand.gameNo && handObj.fullDateTime !== hand.fullDateTime))
        this.props.setSelectedHandList(selectedHandList)
        if (this.state.handList.length !== selectedHandList.length) {
            this.setState({ displayContent: false }, () => {
                this.setState({ isAllHandsSelected: false, displayContent: true }, this.forceUpdate())
            })
        }
        if (selectedHandList.length === 0) {
            this.setState({ showReplayBtn: false })
        }
        this.forceUpdate();
    }
    selectTop20Hands = () => {
        saveActivity({
            hit_page: 'MyHands',
            hit_type: 'selectTop20HandsReplay',
        })
        if (window.messageToNative || (window.external && window.external.NativeDispatch)) {
            localStorage.setItem("selectedHandList",JSON.stringify(this.props.selectedHandList.slice(0, 20)));
            DispatcherFunction("app:menu=3814&name=MYGAME_REPLAYER", {
                "MYGAME_REPLAYER_URL": 'https://' + window.location.hostname +
                `/MultipleReplayerPopup`,
                "location": "yes",
                "height": "720",
                "width": "1000",
                "scrollbars": "yes",
                "status": "yes"
            })}
        else {
            this.setState({ displayContent: false }, () => {
            let newList = this.props.selectedHandList.slice(0, 20)
            this.props.setSelectedHandList(newList);
            this.setState({ displayContent: true, openMultiHandRep: true, isAllHandsSelected: false })
        })}
    }
    prevHand = () => {
        if (this.state.currentReplayerHandIndex > 0) {
            this.setState({ displayContent: false }, () => {
                this.setState({ currentReplayerHandIndex: this.state.currentReplayerHandIndex - 1, displayContent: true })
            })
        }
    }
    nextHand = () => {
        if (this.state.currentReplayerHandIndex < this.props.selectedHandList.length - 1) {
            this.setState({ displayContent: false }, () => {
                this.setState({ currentReplayerHandIndex: this.state.currentReplayerHandIndex + 1, displayContent: true })
            })
        }
    }
    openThisHand = (currentReplayerHandIndex) => {
        this.setState({ displayContent: false }, () => {
            this.setState({ currentReplayerHandIndex, displayContent: true })
        })
    }

    render() {
        const themeColor = getColor();
        const themeTextColor = getTextColor();
        const themeHoverColor = getHoverColor();
        const themeDarkTextColor = getDarkTextColor();
        let fullVersion = 0
        // console.log("navigator.appVersion", navigator.appVersion)
        if (navigator.appVersion.includes("Mac")) {
            if (navigator.appVersion.includes("Mobile")) {
                let osVersion = /OS (\d+)_(\d+)_?(\d+)?/.exec(navigator.appVersion);
                fullVersion = parseFloat(osVersion[1] + '.' + osVersion[2] + osVersion[3]);
                if (fullVersion > 12.10) {
                    fullVersion = 13
                } else {
                    fullVersion = 12
                }
            } else {
                let osVersion = /OS X (\d+)_(\d+)_?(\d+)?/.exec(navigator.appVersion);
                fullVersion = parseFloat(osVersion[1] + '.' + osVersion[2]);
                if (fullVersion > 10.13) {
                    fullVersion = 13
                } else {
                    fullVersion = 12
                }
            }
        } else {
            fullVersion = 13;
        }
        return (
            <div>
                <style>{`\
                  .staredHandColor {\
                    color: ${themeColor};\
                  }\
                  .staredHandColor:hover {\
                    color: ${themeColor};\
                  }\
                  .staredHandColorUnstar {\
                    color: #C1C1C1;\
                  }\
                  .MyHandsCheckBoxSelected {\
                    background-color: ${themeColor};\
                    border-color: ${themeColor};\
                  }\
                  .ReplayHandsBtn, .shareToMomentButton {\
                    border-color: ${themeColor};\
                    color: ${themeDarkTextColor};\
                  }\
                  .ReplayHandsBtnFixedBottom, .HandLimitBtn, .MultiHandReplay_viewHands, .mutireplayer_shareHandButton,
                   .multiReplayer_crossButton, .mutireplayer_shareHandButton {\
                    border-color: ${themeColor};\
                    background-color: ${themeColor};\
                    color: ${themeTextColor};\
                  }\
                  .ReplayHandsBtnFixedBottom:hover, .HandLimitBtn:hover, .HandLimitCloseBtn,
                   .MultiHandReplay_viewHands:hover, .mutireplayer_shareHandButton:hover, .multiReplayer_crossButton:hover,
                   .mutireplayer_shareHandButton:hover {\
                    background-color: #FFFFFF;\
                    color: ${themeDarkTextColor};\
                  }\
                  .HandLimitCloseBtn:hover, .ReplayHandsBtn:hover {\
                    background-color: ${themeColor};\
                    color: ${themeTextColor};\
                  }\
                  .handListSingleRowWrapper_Active {
                    border-color: ${themeColor} !important;\
                  }\
                  .shareToMomentButton:hover {\
                    background-color: ${themeHoverColor};\
                  }\
                `}</style>
                {this.state.displayContent && this.state.openMultiHandRep && this.props.selectedHandList && this.props.selectedHandList.length > 0 ? <div style={{
                    top: 0,
                    left: 0,
                    zIndex: 20000,
                    width: "100%",
                    height: "100%",
                    overflow: "auto",
                    position: "fixed",
                    backgroundColor: '#2c2c34'
                }}>
                    <style>{"\
                        .navbar-fixed-top{\
                        z-index:0 !important;\
                        }\
                    "}</style>
                    {fullVersion && parseFloat(fullVersion) < 13 ? <HandReplayer
                        replayerScreen={'desktop'}
                        isMultipleHands={true}
                        selectedHandCount={this.props.selectedHandList.length}
                        currentReplayerHandIndex={this.state.currentReplayerHandIndex}
                        prevHand={this.prevHand}
                        nextHand={this.nextHand}
                        gameTypeForTitle={this.props.selectedHandList[this.state.currentReplayerHandIndex].gameType}
                        onClose={() => this.setState({ openMultiHandRep: false, currentReplayerHandIndex: 0 })}
                        loginStatus={true}
                        gameNo={this.props.selectedHandList[this.state.currentReplayerHandIndex].gameNo}
                        accountName={localStorage.getItem('accountName')}
                        partitionDate={this.props.selectedHandList[this.state.currentReplayerHandIndex].fullDateTime}
                    /> :
                        <ReplayHand
                            replayerScreen={'desktop'}
                            isMultipleHands={true}
                            selectedHandList={this.props.selectedHandList}
                            selectedHandCount={this.props.selectedHandList.length}
                            currentReplayerHandIndex={this.state.currentReplayerHandIndex}
                            prevHand={this.prevHand}
                            nextHand={this.nextHand}
                            openThisHand={this.openThisHand}
                            setStarFlagOfHnad={(hand, newStarValue) => {
                                this.setStarFlagOfHnad(hand, newStarValue);
                                this.setLocalHandListStarValue(hand, newStarValue);
                            }}
                            loginStatus={true}
                            // i18next={i18next}
                            gameNo={this.props.selectedHandList[this.state.currentReplayerHandIndex].gameNo}
                            partitionDate={this.props.selectedHandList[this.state.currentReplayerHandIndex].fullDateTime}
                            accountName={localStorage.getItem('accountName')}
                            gameTypeForTitle={this.props.selectedHandList[this.state.currentReplayerHandIndex].gameType}
                            onClose={() => {
                                this.setState({ displayContent: false }, () => {
                                    this.setState({ openMultiHandRep: false, displayContent: true, currentReplayerHandIndex: 0 });
                                })
                            }}
                        />}
                </div> : null}
                <span id="openNewFeatureModalBtn" data-target="#NewFeatureModal" data-toggle="modal" style={{ position: "absolute", width: "5px", height: "5px" }}> </span>
                <span id="HandLimitPopupTriggerBtn" data-target="#HandLimitModal" data-toggle="modal" style={{ position: "absolute", left: "6px", width: "5px", height: "5px" }}> </span>
                {this.state.isOnBoard == 1 && JSON.parse(localStorage.getItem('userRole')).indexOf('PLAYER') != -1 && <OnBoard disableOnBoard={this.disableOnBoard} />}
                <EditNoteModal hand={this.state.currentEditNotesHand}
                    i18next={i18next}
                    addNote={this.addNote}
                    editNote={this.editNote}
                    deleteNote={this.deleteNote}
                    setShowNoteModal={this.setShowNoteModal} />
                <HandHistoryFilter
                    showFilterModal={this.state.showFilterModal}
                    getHandHistory={this.getHandHistoryOnChange}
                    levels={this.state.levels}
                    changeFulfilled={this.state.changeFulfilled}
                    getPlayerLevel={this.getPlayerLevel}
                    setFulfilledFlag={(value) => {
                        this.setState({ changeFulfilled: value })
                    }}
                    setShowFilterModal={this.setShowFilterModal}
                />
                <NewFeature i18next={i18next} baseUrlImg={"//" + domain} />
                <HandLimitModal i18next={i18next} baseUrlImg={"//" + domain} selectedHandCount={this.props.selectedHandList.length} selectTop20Hands={this.selectTop20Hands} />
                {this.state.loading ? <Loading /> : null}
                {this.state.displayContent && <span className={this.state.showFilterModal === true ? "wholeHHPage" : ""} >
                    {this.state.handList ? <Media query="(max-width: 200px)" maxWidth={200}>
                        {matches => matches
                            ? <HandHistoryMobile
                                setShowFilterModal={this.setShowFilterModal}
                                setStarFlagOfHnad={this.setStarFlagOfHnad}
                                openNotes={this.openNotes}
                                loading={this.state.loading}
                                handList={this.state.handList}
                                totalProfit={this.state.totalProfit}
                                totalHands={this.state.totalHands}
                                showMoreFlag={this.state.showMoreFlag}
                                showTopButton={this.state.showTopButton}
                                selectHand={this.selectHand}
                                unselectHand={this.unselectHand}
                                isAllHandsSelected={this.state.isAllHandsSelected}
                                showReplayBtn={(fullVersion && parseFloat(fullVersion) < 13) ? false : this.state.showReplayBtn}
                                getHandHistory={this.getHandHistoryOnChange}
                                showMultiReplayer={this.showMultiReplayer}
                                showMoreClicked={this.handleShowMore} />
                            : <HandHistoryDesktop
                                setShowFilterModal={this.setShowFilterModal}
                                setStarFlagOfHnad={this.setStarFlagOfHnad}
                                openNotes={this.openNotes}
                                loading={this.state.loading}
                                handList={this.state.handList}
                                totalProfit={this.state.totalProfit}
                                totalHands={this.state.totalHands}
                                showMoreFlag={this.state.showMoreFlag}
                                showTopButton={this.state.showTopButton}
                                isAllHandsSelected={this.state.isAllHandsSelected}
                                showReplayBtn={(fullVersion && parseFloat(fullVersion) < 13) ? false : this.state.showReplayBtn} setIsAllHandsSelected={this.setIsAllHandsSelected}
                                selectHand={this.selectHand}
                                unselectHand={this.unselectHand}
                                getHandHistory={this.getHandHistoryOnChange}
                                showMultiReplayer={this.showMultiReplayer}
                                showMoreClicked={this.handleShowMore} />}
                    </Media> : null}
                </span>}
            </div>
        )
    }
}


const mapStateToProps = state => {
    return {
        filter: { ...state.handHistory.filter },
        selectedHandList: state.handHistory.selectedHandList,
        lang: state.header.lang
    }
}

const mapDispatchToProps = dispatch => {
    return {
        setHandHistoryFilter: (filter) => dispatch(actions.setHandHistoryFilter(filter)),
        setSelectedHandList: (data) => dispatch(actions.setSelectedHandList(data)),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(HandHistory);



/** WEBPACK FOOTER **
 ** ./src/components/HandHistory/HandHistory.js
 **/